import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { SidenavComponent } from '../../sidenav.component';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { HandbookService } from '../../../shared/services/handbook.service';
import { saveAs } from 'file-saver';
import { SidenavService } from '../../sidenav.service';
import { MessageHelper } from '../../../shared/helpers/message.helper';
import { ErrorHelper } from '../../../shared/helpers/error.helper';
@Component({
  selector: 'app-download-handbook',
  templateUrl: './download-handbook.component.html',
  styleUrls: ['./download-handbook.component.scss'],
})
export class DownloadHandbookComponent implements OnInit, OnChanges {
  @Input() sidenav?: SidenavComponent;
  @Input() data: any; // Recebe os dados do Sidenav
  @Input() changeStatus?: boolean;

  formGroup?: FormGroup;

  portName: string = '';

  actualPage: boolean = false;

  controls: { [key: string]: FormControl } = {
    port: new FormControl(),
    commodity: new FormControl(),
  };

  constructor(
    private handbookService: HandbookService,
    private formBuilder: FormBuilder,
    private router: Router,
    private service: SidenavService,
    private messageHelper: MessageHelper,
    private errorHelper: ErrorHelper
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.changeStatus) {
      this.formStatusControl();
    }
  }

  ngOnInit() {
    this.actualPage = this.router.url.endsWith('detail');
  }

  formStatusControl = () => {
    this.portName = '';

    // Define o nome do porto corretamente
    if (!Array.isArray(this.data)) {
      this.portName = this.data.nomePorto;
    } else if (this.data.length === 1) {
      this.portName = this.data[0].port;
    }

    // Cria o FormArray com base no formato
    const portsArray = Array.isArray(this.data)
      ? this.formBuilder.array(
          this.data.map((port) =>
            this.formBuilder.group({
              descricao: [port.port],
              checked: [true],
            })
          )
        )
      : this.formBuilder.array([
          this.formBuilder.group({
            descricao: [this.data.nomePorto],
            checked: [true],
          }),
        ]);

    this.formGroup = this.formBuilder.group({
      ports: portsArray,
      name: ['', [Validators.required, Validators.minLength(4)]],
      email: ['', [Validators.required, Validators.email]],
      company: new FormControl(''),
      agreed: [false, Validators.requiredTrue],
    });
  };

  submitted = false;

  get ports(): FormArray {
    return this.formGroup?.get('ports') as FormArray;
  }

  getSelectedPorts() {
    if (!Array.isArray(this.formGroup?.value.ports)) {
      return null;
    }
    return this.formGroup.value.ports
      .filter((port: { checked: any }) => port.checked)
      .map((port: { descricao: any; idHandbook: any }) => ({
        descricao: port.descricao,
        idHandbook: port.idHandbook,
      }));
  }

  checkControl(value: any) {
    console.log(this.getSelectedPorts());
  }

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup?.controls ?? {};
  }

  async onSubmit() {
    this.sidenav?.controller?.close();
    this.service.notifyClosed();
    this.submitted = true;

    if (this.formGroup?.invalid) {
      return;
    }

    // 1️⃣ Garante que sempre temos um array
    const dataArray = Array.isArray(this.data) ? this.data : [this.data];

    // 2️⃣ Pega ports selecionados
    const selectedPorts = Array.isArray(this.formGroup?.value.ports)
      ? this.formGroup.value.ports
          .filter((p: any) => p.checked)
          .map((p: any) => p.descricao)
      : [this.data.nomePorto];

    // 3️⃣ Filtra os ports
    const filteredData = dataArray.filter((item: any) =>
      selectedPorts.includes(item.port || item.nomePorto)
    );

    // 4️⃣ Extrai os idHandBook (sem usar flatMap)
    let handBookIds: number[] = [];
    filteredData.forEach((item: any) => {
      if (item.handbooks && Array.isArray(item.handbooks)) {
        item.handbooks.forEach((h: any) => {
          if (h.idHandBook) handBookIds.push(h.idHandBook);
        });
      } else if (item.idHandbook) {
        handBookIds.push(item.idHandbook);
      }
    });

    try {
      // 5️⃣ Faz a requisição
      await this.handbookService.requestDownload({
        idHandbooks: handBookIds ?? [],
        fullName: this.formGroup?.value.name ?? '',
        corporateEmail: this.formGroup?.value.email ?? '',
        company: this.formGroup?.value.company ?? '',
      });
      this.messageHelper.send(
        "The request was sent. Soon you'll receive it in your inbox."
      );
    } catch (err) {
      this.errorHelper.catch(err, {
        401: 'Something went wrong, check and try again',
      });
    } finally {
      this.submitted = false;
    }
  }

  public onSidenavClosed(): void {
    this.sidenav?.controller?.close();
  }
}
